import { Component, OnInit} from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { commonService } from '../../service/common.service';
import { ecommerceService } from '../../service/ecommerce.service';
import { HttpErrorResponse } from '@angular/common/http'
import { Router } from '@angular/router';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-addcategory',
  templateUrl: './addcategory.component.html',
  styleUrls: ['./addcategory.component.css'],
  providers:[commonService,ecommerceService]
})
export class AddcategoryComponent implements OnInit {
category:any;
categoryForm: FormData;
formvailidation=false;
msg:string;
isError=false;
categoryId:any;
  constructor(private _common:commonService,private ecommerce:ecommerceService,private router:Router,private route: ActivatedRoute) {
    // reset form 
    this.category = {
      Category: '',
      Status:''
    }
   }

  ngOnInit() {

        this.route.queryParams.subscribe(params => { 
          if(params['cid']){
            this.categoryId = atob(params['cid']);
            this.ecommerce.editcategory(this.categoryId).subscribe((data : any)=>{
              if(data.error==0){ 
                this.category = {
                  Category:data.results.name,
                  Status:data.results.status
                }
              }else{
                if(data.message=="Failed to authenticate token."){
                  this.router.navigate(['/admin']);
                }else{
                this.msg = data.message;
                this.isError = true;
                }
              }

            });

          }
      });
  }
  register(categoryForm) {
    categoryForm.value.userid=this._common.user.id;

    if(categoryForm.status=="INVALID"){
       this.formvailidation=true;
       this.msg="Please fill all required fields.";
     }else{
          this.formvailidation=false;
          if(this.categoryId){
            categoryForm.value.id=this.categoryId;
                  this.ecommerce.updatecategory(categoryForm.value).subscribe((data : any)=>{
                    if(data.error==0){  
                      localStorage.setItem('isSuccess','Yes');
                      localStorage.setItem('msg','Category updated successfully.');
                      this.router.navigate(['/admin/ecommerce/viewcategory']);
                    }else{
                      if(data.message=="Failed to authenticate token."){
                      this.router.navigate(['/admin']);
                      }else{
                      this.formvailidation=true;
                      this.msg = data.message;
                      this.isError = true;
                      }
                    }
                },
              (error : HttpErrorResponse)=>{
                this.isError = true;
                this.msg="internal server error!";
              });
         }else{
               this.ecommerce.addcategory(categoryForm.value).subscribe((data : any)=>{
                 if(data.error==0){ 
                   localStorage.setItem('isSuccess','Yes');
                   localStorage.setItem('msg','Category added successfully.');
                   this.router.navigate(['/admin/ecommerce/viewcategory']);
                 }else{
                   if(data.message=="Failed to authenticate token."){
                     this.router.navigate(['/admin']);
                   }else{
                   this.formvailidation=true;
                   this.msg = data.message;
                   this.isError = true;
                   }
                 }
             },
           (error : HttpErrorResponse)=>{
             this.isError = true;
             this.msg="internal server error!";
           });
       } 
   
     }   
 }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/ecommerce/addcategory/addcategory.component.ts